import React from 'react';
import PropTypes from 'prop-types';

export default function Customers(props) {
  const { height, width, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 1672 1204" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1139.96 516.117C1204.29 511.989 1264.36 482.515 1306.98 434.16C1349.61 385.804 1371.32 322.516 1367.34 258.177C1371.32 193.839 1349.61 130.55 1306.98 82.195C1264.36 33.8395 1204.29 4.36529 1139.96 0.237793C1075.59 4.36813 1015.46 33.8215 972.74 82.1577C930.019 130.494 908.174 193.78 911.984 258.177C908.174 322.575 930.019 385.861 972.74 434.197C1015.46 482.533 1075.59 511.986 1139.96 516.117ZM531.996 516.117C596.325 511.989 656.39 482.515 699.016 434.16C741.642 385.804 763.349 322.516 759.373 258.177C763.349 193.85 741.652 130.571 699.04 82.2174C656.428 33.8638 596.38 4.38223 532.063 0.237793C467.685 4.36813 407.562 33.8215 364.84 82.1577C322.119 130.494 300.274 193.78 304.084 258.177C300.274 322.575 322.119 385.861 364.84 434.197C407.562 482.533 467.618 511.986 531.996 516.117ZM531.996 688.054C354.909 688.054 0 788.368 0 988.995V1204H1063.99V989.062C1063.99 788.702 708.949 688.121 532.063 688.121L531.996 688.054ZM1139.96 688.054C1117.89 688.054 1093.15 689.793 1066.4 692.334C1112.48 726.943 1149.97 771.713 1175.94 823.165C1201.91 874.616 1215.66 931.363 1216.13 988.995V1204H1671.96V989.062C1671.96 788.702 1317.05 688.054 1139.96 688.054Z"
        fill={iconColor}
      />
    </svg>
  );
}

Customers.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Customers.defaultProps = {
  width: 22,
  height: undefined,
  iconColor: '#000'
};
